import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  const { login, currentUser, isSuperAdmin } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
    // If already logged in, redirect based on role
    if (currentUser) {
      if (isSuperAdmin()) {
        navigate('/admin');
      } else {
        navigate('/');
      }
    }
  }, [currentUser, isSuperAdmin, navigate]);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      setError('Email and password are required');
      return;
    }
    
    try {
      setError('');
      setIsLoading(true);
      
      console.log('Attempting login with:', { email, password: '********' });
      const result = await login(email, password);
      console.log('Login result:', result);
      
      if (result.success) {
        // Navigate based on user role (handled in useEffect)
        console.log('Login successful, redirecting...');
      } else {
        setError(result.message || 'Failed to login');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Failed to login: ' + (err.message || 'Unknown error'));
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <Container>
      <Row className="justify-content-center mt-5">
        <Col md={6} lg={5}>
          <Card className="shadow-lg border-0">
            <Card.Body className="p-5">
              <div className="text-center mb-4">
                <h2 className="fw-bold">Welcome Back</h2>
                <p className="text-muted">Sign in to your account</p>
              </div>
              
              {error && <Alert variant="danger">{error}</Alert>}
              
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoFocus
                  />
                </Form.Group>
                
                <Form.Group className="mb-4">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </Form.Group>
                
                <Button 
                  type="submit" 
                  variant="primary" 
                  className="w-100 py-2"
                  disabled={isLoading}
                >
                  {isLoading ? 'Signing in...' : 'Sign In'}
                </Button>
              </Form>
              
              <div className="text-center mt-4">
                <p>
                  Don't have an account? <Link to="/register">Sign up</Link>
                </p>
              </div>
              
              <div className="text-center mt-3">
                <small className="text-muted">
                  For admin access: admin@example.com / admin123
                </small>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Login;
